import { Link } from "react-router-dom";
import { ArrowRight, Gift } from "lucide-react";

export const GiftStrip = () => (
  <section className="relative overflow-hidden bg-[#0c2a1f] py-12 text-white" data-testid="home-gift-strip">
    <div className="absolute inset-y-0 right-[18%] hidden w-6 bg-red-600 sm:block" />
    <div className="relative mx-auto flex max-w-7xl flex-col items-start gap-6 px-4 sm:px-6 md:flex-row md:items-center md:justify-between">
      <div className="flex items-start gap-4">
        <Gift className="h-12 w-12 shrink-0 rounded-full bg-red-600 p-2.5 ring-4 ring-amber-300" />
        <div>
          <div className="eyebrow !text-lime-300">Christmas gift vouchers</div>
          <h2 className="font-display text-3xl font-black uppercase leading-none tracking-tight sm:text-4xl">Stuck for a gift?</h2>
          <p className="mt-2 max-w-xl text-sm text-slate-200">Give a Sports Shields gift voucher – any amount from €20 to €200. They design their own shield, and it never expires. Printable gift card included.</p>
        </div>
      </div>
      <Link to="/gift" className="btn-blaze flex shrink-0 items-center gap-2 px-6 py-3 text-sm" data-testid="home-gift-button">Buy a gift voucher <ArrowRight className="h-4 w-4" /></Link>
    </div>
  </section>
);
